import { type BlogCategories } from '#app/components/BlogCategoriesInput/types.js';
import {
  COMMON_CATEGORIES,
  NEW_CATEGORIES,
} from '#app/components/CategoryTag/constants.js';

export const getExpectedCategoriesForUser = ({
  categories,
}: {
  categories: BlogCategories;
}): BlogCategories => {
  return categories.filter(({ id, name }) => {
    if (id === 'all') return true;

    return [...COMMON_CATEGORIES, ...NEW_CATEGORIES].includes(name);
  });
};
